import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoopByMachineShellComponent } from './components/loop-by-machine-shell/loop-by-machine-shell.component';
import { LoopByMachineTruckShellComponent } from './components/loop-by-machine-truck-shell/loop-by-machine-truck-shell.component';
import { LoopByOperatorShellComponent } from './components/loop-by-operator-shell/loop-by-operator-shell.component';
import { LoopByOperatorTruckShellComponent } from './components/loop-by-operator-truck-shell/loop-by-operator-truck-shell.component';
import { LoopEmbeddedByMachineTruckComponent } from './components/loop-embedded-by-machine-truck/loop-embedded-by-machine-truck.component';
import { ReportCartirVsProductionComponent } from './components/report-cartir-vs-production/report-cartir-vs-production.component';
import { ReportCartirComponent } from './components/report-cartir/report-cartir.component';
import { ReportCasComponent } from './components/report-cas/report-cas.component';
import { ChecklistShellComponent } from './components/report-checklist/checklist-shell/checklist-shell.component';
import { ReportComputerHistoryComponent } from './components/report-computer-history/report-computer-history.component';
import { ReportDownloadHistoryComponent } from './components/report-download-history/report-download-history.component';
import { ReportDrillHcmComponent } from './components/report-drill-hcm/report-drill-hcm.component';
import { ReportDrillingComponent } from './components/report-drilling/report-drilling.component';
import { ReportExplosiveComponent } from './components/report-explosive/report-explosive.component';
import { ReportFrontsComponent } from './components/report-fronts/report-fronts.component';
import { ReportHourmeterFuelComponent } from './components/report-hourmeter-fuel/report-hourmeter-fuel.component';
import { ReportMachineStatusComponent } from './components/report-machine-status/report-machine-status.component';
import { MarineShellComponent } from './components/report-marine/marine-shell/marine-shell.component';
import { ReportMessengerComponent } from './components/report-messenger/report-messenger.component';
import { ReportMonthlyStatePerOperatorComponent } from './components/report-monthly-state-per-operator/report-monthly-state-per-operator.component';
import { ReportOperationalDisciplineComponent } from './components/report-operational-discipline/report-operational-discipline.component';
import { ReportSpotConditionComponent } from './components/report-spot-condition/report-spot-condition.component';
import { ReportTransitComponent } from './components/report-transit/report-transit.component';
import { ReportVitalSignsHourometerComponent } from './components/report-vital-signs-hourmeter/report-vital-signs-hourmeter.component';
import { ReportVitalSignsComponent } from './components/report-vital-signs/report-vital-signs.component';
import { ReportZoneHistoryComponent } from './components/report-zone-history/report-zone-history.component';

const routes: Routes = [
  {
    path: 'machinestatus',
    component: ReportMachineStatusComponent,
    pathMatch: 'full',
  },
  {
    path: 'transit',
    component: ReportTransitComponent,
    pathMatch: 'full',
  },
  {
    path: 'messenger',
    component: ReportMessengerComponent,
    pathMatch: 'full',
  },
  {
    path: 'monthly-state-per-operator',
    component: ReportMonthlyStatePerOperatorComponent,
    pathMatch: 'full',
  },
  {
    path: 'checklist',
    component: ChecklistShellComponent,
    pathMatch: 'full',
  },
  {
    path: 'marine',
    component: MarineShellComponent,
    pathMatch: 'full',
  },
  {
    path: 'drilling',
    component: ReportDrillingComponent,
    pathMatch: 'full',
  },
  {
    path: 'drilling-hcm',
    component: ReportDrillHcmComponent,
    pathMatch: 'full',
  },
  {
    path: 'loops-by-operator',
    component: LoopByOperatorShellComponent,
    pathMatch: 'full',
  },
  {
    path: 'loops-by-machine',
    component: LoopByMachineShellComponent,
    pathMatch: 'full',
  },
  {
    path: 'loops-machine-truck',
    component: LoopByMachineTruckShellComponent,
    pathMatch: 'full',
  },
  {
    path: 'loops-by-operator-truck',
    component: LoopByOperatorTruckShellComponent,
    pathMatch: 'full',
  },
  {
    path: 'fronts',
    component: ReportFrontsComponent,
    pathMatch: 'full',
  },
  {
    path: 'explosives',
    component: ReportExplosiveComponent,
    pathMatch: 'full',
  },
  {
    path: 'spot-condition',
    component: ReportSpotConditionComponent,
    pathMatch: 'full',
  },
  {
    path: 'vital-signs',
    component: ReportVitalSignsComponent,
    pathMatch: 'full',
  },
  {
    path: 'zone-history',
    component: ReportZoneHistoryComponent,
    pathMatch: 'full',
  },
  {
    path: 'mtbox-history',
    component: ReportComputerHistoryComponent,
    pathMatch: 'full',
  },
  {
    path: 'download-history',
    component: ReportDownloadHistoryComponent,
    pathMatch: 'full',
  },
  {
    path: 'signal-vital-hourmeter',
    component: ReportVitalSignsHourometerComponent,
    pathMatch: 'full',
  },
  {
    path: 'hourmeter-fuel',
    component: ReportHourmeterFuelComponent,
    pathMatch: 'full',
  },
  {
    path: 'cartir-production',
    component: ReportCartirComponent,
    pathMatch: 'full',
  },
  {
    path: 'cartir-vs-production',
    component: ReportCartirVsProductionComponent,
    pathMatch: 'full',
  },
  {
    path: 'loop-embedded-machine-truck',
    component: LoopEmbeddedByMachineTruckComponent,
    pathMatch: 'full',
  },
  {
    path: 'cas',
    component: ReportCasComponent,
    pathMatch: 'full',
  },
  {
    path: 'operational-discipline',
    component: ReportOperationalDisciplineComponent,
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportRoutingModule {}
